import { DeviceCheckResult } from '~/generated/graphql';
import checkSecureContext from '~/helpers/deviceChecks/checkSecureContext';
import { DeviceCheckMetadata } from '~/types';

const checkSecureNetwork: DeviceCheckMetadata['check'] = () => {
  if (checkSecureContext()) {
    return {
      result: DeviceCheckResult.Pass,
    };
  }
  return {
    result: DeviceCheckResult.Fail,
  };
};

export default checkSecureNetwork;
